<app-section-header title="Fluxo de pessoas" />

<div>
  <canvas id="canvas">{{ chart }}</canvas>
</div>
